/*
* AGP events
* Menu
*/

import $ from "jquery";
import 'bootstrap';
import "../AGP/PLUGS/bootstrap-table-master/dist/bootstrap-table.min.js";


export default class Events {

    constructor(el) {
        this.DOM = {el: el};
    }

    init() {
        let _this = this;

        $(document).on("click", "._open_fusions", function () {
            $(".form_societes_fusion").slideDown();
            $("select.multiple-select").multipleSelect('refresh');
        });

    }
}